// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";

function getViewModel(driverSuspensionData) {
  return List.map((function (suspensionRecord) {
                return {
                        expiry_time: suspensionRecord.expiry_time,
                        comment: suspensionRecord.comment,
                        reason: suspensionRecord.reason,
                        status: suspensionRecord.status,
                        administrator: suspensionRecord.administrator,
                        event_mode: suspensionRecord.event_mode,
                        event_time: suspensionRecord.event_time
                      };
              }), driverSuspensionData.suspension_history);
}

var DriverSuspensionListVMMapper = {
  getViewModel: getViewModel
};

export {
  DriverSuspensionListVMMapper ,
  
}
/* No side effect */
